module.exports = __webpack_public_path__ + "img/gray-send-60min.525daa59.png";